import Service, { service } from '@ember/service';
import { alert } from '@pnotify/core';
import { isTesting, macroCondition } from '@embroider/macros';

export default class NotifierService extends Service {
  @service intl;

  sendError(message, attrs) {
    if (message instanceof Error) {
      attrs = { ...message.contextVariables, ...attrs };
      message = message.message;
    }

    this.#sendNotification(message, attrs, { type: 'error', delay: 5000 });
  }

  sendSuccess(notification, attrs) {
    this.#sendNotification(notification, attrs, { type: 'success' });
  }

  sendWarning(notification, attrs) {
    this.#sendNotification(notification, attrs, { type: 'notice' });
  }

  jemTriggerError(notification, attrs) {
    this.#sendNotification(notification, attrs, { type: 'error', delay: 120_000 });
  }

  #sendNotification(text, attrs, pnotifyParams, title) {
    if (macroCondition(isTesting())) {
      return;
    }

    const notice = alert({
      title: this.intl.exists(title) ? this.intl.t(title, attrs ?? {}) : title,
      text: this.intl.exists(text) ? this.intl.t(text, attrs ?? {}) : text,
      ...pnotifyParams,
    });

    notice.on('click', () => {
      notice.close();
    });
  }
}
